import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'

import type { FaqItemData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

/**
 * FAQ_ITEM widget — registered sentinel for v2 PDP nested FAQ items.
 *
 * In v2 PDP layouts, FAQ accordion items arrive as nested `widgets` of type FAQ_ITEM. The parent
 * FAQWidget detects their presence via `renderedChildren.length`, then reads their raw
 * `data.faqItem` directly and delegates to FaqDs for rendering (preserving the unified
 * accordion CSS). This widget is registered to suppress "unknown widget type" console warnings;
 * it intentionally renders nothing — the parent owns all accordion rendering.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function FaqItemComponent(_props: PLTypedWidgetProps<FaqItemData>) {
  return null
}

export const FaqItemWidget: PLTypedWidgetInterface<FaqItemData, WidgetType.FAQ_ITEM> = {
  id: WidgetType.FAQ_ITEM,
  errorBoundary: PLBaseErrorBoundary,
  render: FaqItemComponent,
}
